"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoTTypeToPercentIncrease = void 0;
const enums_1 = require("../enums");
exports.DoTTypeToPercentIncrease = {
    "Burning": enums_1.AttributeType.BurnDamageIncrease,
    "Bleeding": enums_1.AttributeType.BleedDamageIncrease,
    "Chill": enums_1.AttributeType.ChillDamageIncrease,
    "Poisoned": enums_1.AttributeType.PoisonDamageIncrease,
    "Curse": enums_1.AttributeType.CurseDamageIncrease,
};
